import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const C3_CollaborativeTeamMeeting = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='C3_CollaborativeTeamMeeting' className='file-pdf-document'>
            <div className='file-template'> 
            <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Individual's Strengths</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtIndividualStrengths' name='txtIndividualStrengths' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Individual's Current Needs</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtIndividualsCurrentNeeds' name='txtIndividualsCurrentNeeds' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Individual's Current Progress</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtIndividualsCurrentProgress' name='txtIndividualsCurrentProgress' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Meeting Results</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtMeetingResults' name='txtMeetingResults' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Possible Goal Additions or Modifications to the Person Centered Plan</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPossibleGoalAdditionsModificationsPersonCenteredPlan' name='txtPossibleGoalAdditionsModificationsPersonCenteredPlan' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Action Steps</b> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Who is Responsible?</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>What are they Responsible for?</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>By When?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtWhoIsResponsible_1' name='txtWhoIsResponsible_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtWhoAreTheyResponsibleFor_1' name='txtWhoAreTheyResponsibleFor_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtByWhen_1' name='txtByWhen_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtWhoIsResponsible_2' name='txtWhoIsResponsible_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtWhoAreTheyResponsibleFor_2' name='txtWhoAreTheyResponsibleFor_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtByWhen_2' name='txtByWhen_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtWhoIsResponsible_3' name='txtWhoIsResponsible_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtWhoAreTheyResponsibleFor_3' name='txtWhoAreTheyResponsibleFor_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtByWhen_3' name='txtByWhen_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtWhoIsResponsible_4' name='txtWhoIsResponsible_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtWhoAreTheyResponsibleFor_4' name='txtWhoAreTheyResponsibleFor_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtByWhen_4' name='txtByWhen_4' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                <tr>
                        <td className='w-750'>
                            <b>Participants Present:</b> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Personal or Professional Relationship to Individual</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPersonalOrProfessionalRelationshipToIndividual_1' name='txtPersonalOrProfessionalRelationshipToIndividual_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPersonalOrProfessionalRelationshipToIndividual_2' name='txtPersonalOrProfessionalRelationshipToIndividual_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_3' name='txtName_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPersonalOrProfessionalRelationshipToIndividual_3' name='txtPersonalOrProfessionalRelationshipToIndividual_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_4' name='txtName_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPersonalOrProfessionalRelationshipToIndividual_4' name='txtPersonalOrProfessionalRelationshipToIndividual_4' className='add-only' /> </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}











